<template>
  <div class="app" :class="{ 'report-default': themeCode === 'default', 'report': themeCode === 'blue' }">
    <div id="outline">
      <div class="outline-header">
        <div class="outline-header-bg">
          <img v-if="themeCode === 'default'" src="../../assets/default/headerbg.png" alt="" />
          <img v-else-if="themeCode === 'blue'" src="../../assets/electricity/headerbg.png" alt="" />
        </div>
        <div class="outline-header-left">
          <div v-if="ImageUrl">
            <img :src="ImageUrl" alt="" />
          </div>
        </div>
        <div class="outline-header-center">
          <div class="outline-header-center-top">
            <img
              :src="themeCode === 'default' ? require('../../assets/default/decorate_left.png') : require('../../assets/electricity/decorate_left.png')"
              alt="">
            <!-- <dv-decoration-1 style="width:200px;height:50px;" /> -->
            <div class="outline-header-center-title">
              {{ TittleName }}
            </div>
            <!-- <dv-decoration-1 style="width:200px;height:50px; transform: rotateY(180deg);" /> -->
            <img
              :src="themeCode === 'default' ? require('../../assets/default/decorate_rigth.png') : require('../../assets/electricity/decorate_rigth.png')"
              alt="">
          </div>
          <div class="outline-header-center-bottom" style="letter-spacing: 0px">
            {{ TittleNameEN }}
          </div>
        </div>

        <div class="outline-header-right">
          <img @click="goBack" :src="themeCode === 'default'
              ? require('../../assets/default/return.png')
              : require('../../assets/electricity/return.png')
            " :alt="$t('report.report.463915-0')" />
        </div>
        <div class="outline-and"></div>
      </div>
      <div class="report-content">
        <div class="report-content-left">
          <div class="tabbar-lists">
            <router-link :to="{ name: 'abnormal' }" active-class="tabbar-router" exact>
              <div class="tabbar-item">
                <div class="tabbar-item-img">
                  <img src="../../assets/report/abnormal.png" alt="" />
                </div>
                <div class="tabbar-item-text">{{ $t('report.report.463915-1') }}</div>
              </div>
            </router-link>
            <router-link :to="{ name: 'energy' }" active-class="tabbar-router" exact>
              <div class="tabbar-item">
                <div class="tabbar-item-img">
                  <img src="../../assets/report/energy.png" alt="" />
                </div>
                <div class="tabbar-item-text">{{ $t('report.report.463915-2') }}</div>
              </div>
            </router-link>

            <router-link :to="{ name: 'electricity' }" active-class="tabbar-router" exact>
              <div class="tabbar-item">
                <div class="tabbar-item-img">
                  <img src="../../assets/report/electricity.png" alt="" />
                </div>
                <div class="tabbar-item-text">{{ $t('report.report.463915-3') }}</div>
              </div>
            </router-link>
            <router-link :to="{ name: 'deviceMoney' }" active-class="tabbar-router" exact>
              <div class="tabbar-item">
                <div class="tabbar-item-img">
                  <img src="../../assets/report/log.png" alt="" />
                </div>
                <div class="tabbar-item-text">{{ $t('report.report.463915-4') }}</div>
              </div>
            </router-link>
            <router-link :to="{ name: 'operation_log' }" active-class="tabbar-router" exact>
              <div class="tabbar-item">
                <div class="tabbar-item-img">
                  <img src="../../assets/report/log.png" alt="" />
                </div>
                <div class="tabbar-item-text">{{ $t('report.report.463915-5') }}</div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="report-content-right">
          <router-view />
        </div>
      </div>
    </div>
    <div class="spin-view" v-if="EnergyState">
      <div class="spin-loading">
        <div class="loader">
          <div class="outer1"></div>
          <div class="middle"></div>
          <div class="inner"></div>
          <div class="loader-title">{{ spinTitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      TittleName: "", // 中文title
      TittleNameEN: "", // 英文title
      ImageUrl: "",

      spinMsg: false,
      spinTitle: this.$t('report.report.463915-6'),

      themeCode: "",
    };
  },

  created() {
    let _this = this; //声明一个变量指向Vue实例this，保证作用域一致

    _this.themeCode = _this.$store.getters.getThemeCode;
  },

  computed: {
    EnergyState() {
      return this.$store.getters.getEnergyState;
    },
  },

  mounted() {
    let _this = this,
      AdminData = JSON.parse(Cookies.get("AdminData"));

    _this.TittleName = AdminData.TittleName;
    _this.TittleNameEN = AdminData.TittleNameEN;
    _this.ImageUrl = AdminData.ImageUrl;
  },

  methods: {
    goBack() {
      this.$router.push({
        name: "smartElectricity",
      });
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
@import "./report_default.scss";
@import "./report.scss";
</style>



// WEBPACK FOOTER //
// src/components/report/report.vue